module.exports = __webpack_public_path__ + "static/media/caracteristicas.66991bb5.jpg";